import { type IntlShape } from 'react-intl'

import {
  directContactFormSubjectPolicyGetByTranslatedSubject,
  directContactFormSubjectPolicyRequiresLogin,
} from './directContactFormSubjectPolicySelectors'

export const directContactFormAccessorSubjectRequiresLogin = ({
  hasPrefilledOrder = false,
  intl,
  subject,
}: {
  hasPrefilledOrder?: boolean
  intl: IntlShape
  subject: string
}): boolean => {
  const { policy } = directContactFormSubjectPolicyGetByTranslatedSubject({
    intl,
    subject,
  })

  return directContactFormSubjectPolicyRequiresLogin({
    hasPrefilledOrder,
    policy,
  })
}
